import { EventEmitter, Injectable } from '@angular/core';
import { ConcessionRegistrationDetailsApiModel, TechnicianInfo } from './concession-registration.models';
import { Observable, ReplaySubject, Subject, of } from 'rxjs';
import { CommunicationService } from '../services/communication.service';
import { ConcessionDataValidationFormUpdateModel } from './concession-basic-profile/data-concession-validation/data-concession-validation.component';

export type TechnicianDataUpdatingModel = {
  commodityType: string;
};

@Injectable({
  providedIn: 'root',
})
export class ConcessionRegistrationService {
  public concessionDataValidationFormUpdated: ReplaySubject<ConcessionDataValidationFormUpdateModel> =
    new ReplaySubject<ConcessionDataValidationFormUpdateModel>();
  public concessionDataValidationFormUpdated$: Observable<ConcessionDataValidationFormUpdateModel> =
    this.concessionDataValidationFormUpdated.asObservable();

  constructor(private communicationService: CommunicationService) {}

  public loadTechnicianInfo(technicianId: string, firstName: string, lastName: string): Observable<ConcessionRegistrationDetailsApiModel> {
    return this.communicationService.getData(
      `concession-registration?id=${technicianId}&lastName=${encodeURIComponent(lastName)}&firstName=${encodeURIComponent(firstName)}`
    );
  }

  public updateConcessionValidationForm(form: ConcessionDataValidationFormUpdateModel) {
    this.concessionDataValidationFormUpdated.next(form);
  }
}
